import { Box, Image, HStack, Text, Center, Divider, Container, Button, Card, CardBody, SimpleGrid, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody, Input, Textarea } from '@chakra-ui/react'
import React from 'react'
import dp from '../static/dp.png';
import { SiLinkedin, SiGithub, SiAngellist } from 'react-icons/si'
import { FaAward, FaUniversity, FaGraduationCap } from 'react-icons/fa';
import { MdOutlineCodeOff, MdFileDownload } from 'react-icons/md';

export default function About() {

  const talkPopOverGetter = () => (
    <Popover>
      <PopoverTrigger>
        <Button colorScheme='blue' fontWeight={"normal"}>Let's Talk</Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Hey, Let's Talk!</PopoverHeader>
        <PopoverBody p={5}>
          <form
            action="https://formspree.io/f/maykzpgb"
            method="POST"
          >
            <Input placeholder='Name' size={"md"} name='name' mb={3} isRequired />
            <Input placeholder='Email' size={"md"} name='email' mb={3} isRequired />
            <Textarea placeholder='Your Message' size={"md"} name='msg' mb={3} isRequired />
            <Button type='submit' fontWeight={"thin"}>Send</Button>
          </form>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )

  return (
    <div className='animate__animated animate__fadeIn'>
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
        <Box className='dp_border'>
          <Image className='dp' src={dp} height={{ base: 125, sm: 130, md: 130, lg: 130 }} />
        </Box>
        <Text fontSize={"2xl"} mt={2} className="user_name">Aryamitra Chaudhuri</Text>
        <Text fontSize={"md"} color={"gray.400"}>Full Stack Software Developer Engineer</Text>
        <HStack mt={7}>
          <a href='https://drive.google.com/drive/folders/1HHCSawgsXs7iopsI6JIRdtZ5MBt33ieE?usp=share_link' target={"_blank"} rel="noreferrer"><Button colorScheme='blue' fontWeight={"normal"} variant={"outline"} leftIcon={<MdFileDownload />}>Resume</Button></a>
          {talkPopOverGetter()}
        </HStack>
        <HStack mt={7}>
          <a href='https://www.linkedin.com/in/aryamitrachaudhuri/' target={"_blank"} rel="noreferrer"><SiLinkedin className="social" /></a>
          <a href='https://github.com/aryamitra06' target={"_blank"} rel="noreferrer"><SiGithub className="social" /></a>
          <a href='https://angel.co/u/aryamitra-chaudhuri' target={"_blank"} rel="noreferrer"><SiAngellist className="social" /></a>
        </HStack>
        <Center height='50px' mt={3}>
          <Divider orientation='vertical' className='vertical_divider' />
        </Center>
        <Text fontSize={"2xl"}
          bgGradient='linear(to-l, #2193b0, #6dd5ed)'
          bgClip='text'
          fontWeight={"semibold"}
        >
          About Me
        </Text>
        <Container>
          <Text fontSize={"sm"} p={1} textAlign={"center"}>
            A self-taught programmer, creative coder, user experience enthusiast and self-proclaimed developer specializes in full stack development.
            Passionate about problem solving in real world scenarios and contributing to open-source community.
          </Text>
        </Container>
        <Container mt={4}>
          <SimpleGrid columns={2} spacing={4}>
            <Card>
              <CardBody display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <FaAward style={{ marginBottom: 13, fontSize: 30 }} />
                <Text>Experience</Text>
                <Text fontSize={"sm"} color={"gray.400"}>Less than 1 Year</Text>
              </CardBody>
            </Card>
            <Card>
              <CardBody display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <MdOutlineCodeOff style={{ marginBottom: 13, fontSize: 30 }} />
                <Text>Projects</Text>
                <Text fontSize={"sm"} color={"gray.400"}>10+</Text>
              </CardBody>
            </Card>
            <Card>
              <CardBody display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <FaUniversity style={{ marginBottom: 13, fontSize: 30 }} />
                <Text>Current Institution</Text>
                <Text fontSize={"sm"} color={"gray.400"}>KIIT DU</Text>
              </CardBody>
            </Card>
            <Card>
              <CardBody display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <FaGraduationCap style={{ marginBottom: 13, fontSize: 30 }} />
                <Text>Stream</Text>
                <Text fontSize={"sm"} color={"gray.400"}>B. Tech CSE (19-23)</Text>
              </CardBody>
            </Card>
          </SimpleGrid>
        </Container>
      </Box>
    </div>
  )
}
